import { useState, useEffect, useCallback } from 'react'

export type DeviceType = 'mobile' | 'tablet' | 'desktop'

export const DEVICE_BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024
} as const

export const useDeviceDetection = () => {
  const [deviceType, setDeviceType] = useState<DeviceType>('desktop')
  const [isHydrated, setIsHydrated] = useState(false)

  const getDeviceType = useCallback((): DeviceType => {
    if (typeof window === 'undefined') return 'desktop'

    const width = window.innerWidth
    if (width <= DEVICE_BREAKPOINTS.MOBILE) return 'mobile'
    if (width <= DEVICE_BREAKPOINTS.TABLET) return 'tablet'
    return 'desktop'
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType())
    }

    // Set initial device type
    handleResize()
    setIsHydrated(true)

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [getDeviceType])

  return {
    deviceType,
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
    isHydrated
  }
}

export default useDeviceDetection
